<template>
  <div class="no-select">
    <div class="options">
      <v-switch v-model="listen" class="switch">
        <template #label>
          <v-btn icon small color="primary">
            <app-icon icon="headset"/>
          </v-btn>
        </template>
      </v-switch>
      <v-switch v-model="truncate" class="switch">
        <template #label>
          <v-btn icon small color="primary">
            <app-icon icon="unfold-more"/>
          </v-btn>
        </template>
      </v-switch>
    </div>
    <progress-indicator/>
    <div ref="container">
      <div v-for="[name, row] in Object.entries(getDrumMatrix)" :key="name" class="grid-row">
        <div class="grid">
          <span :class="['sound text-capitalize', truncate ? 'text-truncate' : '']" ref="names"
                @click="play(name, true)">{{ name }}</span>
          <div v-for="(val,bit) in row.slice(0, getDrumMatrixSize)" :key="bit"
               class="block"
               @mousedown="onMouseDown(name, bit)"
               @mouseup="mouseDown=false" ref="bits"
               @mouseenter="onMouseEnter(name, bit)"
               :style="{backgroundColor: val ? '#E7FF79' : `${Math.floor(bit/4)%2 ? '#555557' :'#6B6F69'}`}"/>
        </div>
      </div>
    </div>
    <div>
      <app-slider value-name="volume" :initial-value="1" :min="-60" :max="12"
                  @valueChanged="SET_VOLUME"/>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { DRUMS }   from 'misc/Constants'

  let audioManager

  export default {
    name:       'Drums',
    components: {
      ProgressIndicator: () => import(/* webpackChunkName: "components" */ 'components/ProgressIndicator'),
      AppSlider:         () => import(/* webpackChunkName: "components" */ 'components/AppSlider'),
    },
    async created() {
      this.$store.dispatch('visualization/setDrumMatrix')
      const module = await import(/* webpackChunkName: "audio-manager" */ 'models/AudioManager')
      audioManager = module.default
      await audioManager.add('drums')
    },
    mounted() {
      const initialIndicator = {
        initial:   this.$refs.names[0].getBoundingClientRect().width,
        translate: this.$refs.names[0].getBoundingClientRect().width,
        value:     this.$refs.bits[0].getBoundingClientRect().width,
        height:    this.$refs.container.getBoundingClientRect().height,
        duration:  0,
      }
      this.setIndicator(initialIndicator)
    },
    data() {
      return {
        mouseDown: false,
        truncate:  true,
        listen:    false,
      }
    },
    computed:   {
      ...mapGetters('visualization', ['getDrumMatrix', 'getDrumMatrixSize']),
    },
    methods:    {
      ...mapActions('visualization', ['setIndicator', 'setDrumMatrixBit']),
      ...mapActions('transport', ['toggleDrums', 'setPlayerVolume']),
      onMouseDown(name, bit) {
        this.mouseDown = true
        this.setDrumMatrixBit({ name, bit })
        this.play(name)
      },
      onMouseEnter(name, bit) {
        if(this.mouseDown) {
          this.setDrumMatrixBit({ name, bit })
          this.play(name)
        }
      },

      play(name, header = false) {
        if(this.listen || header) {
          audioManager.drums.play(name)
        }
      },
      SET_VOLUME(value) {
        this.setPlayerVolume({ playerName: DRUMS, value })
      },
    },
  }
</script>

<style scoped>
  .grid-row {
    display:    block;
    overflow-x: auto;
  }

  .grid {
    display:         flex;
    justify-content: center;
    align-items:     center;
    flex:            1;
    font-size:       12px;
  }

  .block {
    padding: .5rem;
    border:  1px solid black;
    flex:    auto;
  }

  .sound {
    flex:  auto;
    width: 20em;
  }

  .options {
    display: flex;
  }

  .switch {
    padding: 0px 10px;
  }
</style>
